// Notes SC4 — on-device backup of UNSAVED note drafts (decision 1). PHI on the device, so the rules are strict:
//   • IndexedDB only (database `hud_note_drafts`, one store, key `userId:noteId`) — never localStorage.
//   • An entry holds exactly {userId, noteId, isNew, appointmentId, childId, specialistPatientId, title, content, summary, base,
//     updatedAt}: nothing else (no tokens, no other notes, no patient names beyond the note's own text).
//   • Written only while a note is dirty; deleted once the server confirms the save (editor.js decides when).
//   • Wiped on EVERY sign-out: index.html _purgeLocalUserState() deletes the database and leaves the
//     `hud_drafts_wipe` flag (no user data), so a delete cut short by the sign-out navigation is finished here,
//     before anything is read, on the next load.
//   • Only the signed-in user's entries are ever read; other users' entries are deleted on first access.
//   • Unavailable (private mode / blocked / quota): every call resolves quietly (false / null / []), logged ❌
//     once — the editor falls back to SC2's memory-only behaviour.
// Reports R3e (ruling D2): the IndexedDB plumbing moved to src/lib/draft-store.js (shared with the report editor's
// own database, `hud_report_drafts`); this file keeps the notes' API, entry whitelist and database unchanged.
import { makeDraftStore } from '../../lib/draft-store.js';

const _store = makeDraftStore({ db: 'hud_note_drafts', label: 'note draft backup' });

export function bkAvailable(){ return _store.available(); }

// SC6a R3b: a sanity cap on the stored doc. Above it the entry keeps `content` (the plain mirror) and drops `contentDoc`
// — the text is never lost, only its formatting.
export const BK_DOC_CAP = 1024 * 1024;
// Write/replace one entry — exactly the allowed fields. → true once committed.
export async function bkPut(e){
  let contentDoc = (e.contentDoc && typeof e.contentDoc === 'object') ? e.contentDoc : null;
  if(contentDoc){ try{ if(JSON.stringify(contentDoc).length > BK_DOC_CAP) contentDoc = null; }catch(_){ contentDoc = null; } }
  const entry = { userId:String(e.userId), noteId:String(e.noteId), isNew:!!e.isNew, appointmentId:e.appointmentId||null /* SC5: a new note's session link */, childId:e.childId||null,
    specialistPatientId:e.specialistPatientId||null, title:e.title||'', content:e.content||'', contentDoc /* SC6a: the rich doc (capped) */,
    clin:e.clin!==false /* SC6a: false = the free tier's hidden field — recovery then writes NEITHER clinical column */, summary:e.summary||'',
    base:e.base||null, updatedAt:new Date().toISOString() };
  return _store.put(entry.userId, entry.noteId, entry);
}
export async function bkGet(userId, noteId){ return _store.get(userId, noteId); }
export async function bkDel(userId, noteId){ return _store.del(userId, noteId); }
// This user's entries. Any other user's entry is deleted on the way (the per-user boundary).
export async function bkAll(userId){ return _store.all(userId); }
